import {seoMetadata as SeoMetadata} from "@next/utils"
import State from "../../../../models/State"
import {CATEGORY, SearchApiRequestTypes, NO_INDEX_NO_FOLLOW_META_ROBOTS} from "../../../../config/constants"

interface SeoMetadata {
    title: string
    keywords: string
    description: string
    robots: string
    canonical?: string
}

export const checkStructuredBrowsingAndCategoryFilter = (state: State, seoMetadata: SeoMetadata) => {
    const newSeoMetadata: SeoMetadata = {...seoMetadata}
    if (
        state.request.type === SearchApiRequestTypes.Category &&
        (state.search.enableStructuredBrowsing || state.search.addNoIndexToCategoryFilterUrls) &&
        (state.request.url.includes(`${CATEGORY}-`) || state.request.url.includes(`/-/`))
    ) {
        newSeoMetadata.robots = NO_INDEX_NO_FOLLOW_META_ROBOTS
    }
    return newSeoMetadata
}
